
const ProductFaq = ({ faqs }) => {
  return (
    <div className="accordion" id="accordionFlushExample">
      {faqs.map((faq, index) => {
        const collapseId = `flush-collapse-${index}`;
        const headingId = `flush-heading-${index}`;

        return (
          <div key={index} className="accordion-item">
            <h3 className="accordion-header" id={headingId}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#${collapseId}`}
                aria-expanded="false"
                aria-controls={collapseId}
              >
                {faq.question}
              </button>
            </h3>
            <div
              id={collapseId}
              className="accordion-collapse collapse"
              aria-labelledby={headingId}
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body cat-faq">
                <p>{faq.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductFaq;